import './Inventory.css';
import { useLocation } from 'react-router-dom';
import { Skin } from '../Skin/Skin';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { SkinType } from '../../utils/types';

const items = [
    { id: '1', amount: 10 },
    { id: '2', amount: 15 },
    { id: '3', amount: 20 },
];

export const Inventory = ({ setIsInventoryOpen }: { setIsInventoryOpen: Dispatch<SetStateAction<boolean>> }) => {
    const location = useLocation();
    const isClassic: boolean = location.pathname === '/rooms';

    const [isChoiceContainerOpen, setIsChoiceContainerOpen] = useState(false);
    const [arrChoiceSkin, setArrChoiceSkin] = useState<SkinType[]>([]);

    const close = () => {
        setIsInventoryOpen(false);
    };

    useEffect(() => {
        if (arrChoiceSkin.length === 0) {
            setIsChoiceContainerOpen(false);
        } else {
            setIsChoiceContainerOpen(true);
        }
        console.log(arrChoiceSkin);
    }, [arrChoiceSkin]);

    const buttonPagination: {
        name: string;
    }[] = [{ name: '2' }, { name: '4' }, { name: '6' }, { name: '8' }, { name: '10' }, { name: 'Все' }];

    return (
        <>
            <div className="inventory inventory_open">
                <div className="inventory__header">
                    <span className="inventory__text">Инвентарь</span>
                </div>
                <button onClick={close} className="inventory__close-button">
                    <svg className="inventory__close-button-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                        <g fill="#F1F1F1" opacity=".9">
                            <path d="M11.104 2.96 8 6.066 4.896 2.96a1.368 1.368 0 1 0-1.935 1.935L6.065 8 2.96 11.104a1.368 1.368 0 1 0 1.935 1.935l8.143-8.143a1.368 1.368 0 1 0-1.935-1.935z" />
                            <path d="M13.04 13.04c.534-.535.534-1.402 0-1.936L9.934 8 8 9.935l3.104 3.104c.534.535 1.4.535 1.935 0z" opacity=".6" />
                        </g>
                    </svg>
                </button>
                <div className="inventory__sort">
                    <span className="inventory__sort-text">Выделить первые</span>
                    <div className="inventory__sort-button-container">
                        {buttonPagination.map((item, i) => (
                            <button key={i} className="inventory__button-highlight inventory__sort-text">
                                {item.name}
                            </button>
                        ))}
                    </div>
                    <div className="inventory__sort-info-container">
                        <span className="inventory__sort-text inventory__sort-text_first">По цене</span>
                        <span className="inventory__sort-text">Всего 43 шт.</span>
                        <span className="inventory__sort-text">|</span>
                        <span className="inventory__sort-text">43 056.67 р.</span>
                    </div>
                </div>
                <div className="inventory__container">
                    {items.map((item) => (
                        <Skin key={item.id} arrChoiceSkin={arrChoiceSkin} setArrChoiceSkin={setArrChoiceSkin} skin={item} />
                    ))}
                </div>
                {isChoiceContainerOpen && (
                    <div className="inventory__info-container">
                        <div className="inventory__info-container-items">
                            <span className="inventory__info-container-text">Выбрано</span>
                            <span className="inventory__info-container-total">{arrChoiceSkin.length} скинов</span>
                        </div>
                        <div className="inventory__info-container-items">
                            <span className="inventory__info-container-text">На сумму</span>
                            <span className="inventory__info-container-total">
                                {arrChoiceSkin.reduce((total, skin) => total + skin.amount, 0)} руб.
                            </span>
                        </div>
                    </div>
                )}
                <button className="inventory__button-skin">Залить в батл</button>
            </div>
        </>
    );
};
